import { createSlice } from "@reduxjs/toolkit";
import { getStatistics } from "../actions/statistics.actions";

const initialState = {
  statistics: [] as any,
  loading: false,
  error: null as unknown | null,
};
export const partnersSlice = createSlice({
  name: "statistics",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStatistics.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStatistics.fulfilled, (state, action) => {
        state.statistics = action.payload;
        state.loading = false;
      })
      .addCase(getStatistics.rejected, (state, action) => {
        state.statistics = [];
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default partnersSlice.reducer;
